var map = {
	"./BIFI-logo.svg": 297,
	"./avax-pairs/COM-AVAX.png": 1150,
	"./avax-pairs/DAI-AVAX.png": 1151,
	"./avax-pairs/ETH-AVAX.png": 1152,
	"./avax-pairs/LYD-AVAX.png": 1153,
	"./avax-pairs/OLIVE-AVAX.png": 1154,
	"./avax-pairs/OLIVE-USDT.png": 1155,
	"./avax-pairs/PNG-AVAX.png": 1156,
	"./avax-pairs/SNOB-AVAX.svg": 1157,
	"./avax-pairs/SNOB3P.png": 1158,
	"./avax-pairs/USDT-AVAX.png": 1159,
	"./avax-pairs/ZETH.svg": 1160,
	"./banners/CakeBanner.svg": 596,
	"./binance-wallet.png": 1161,
	"./bnb-pairs/AAVE-BNB.svg": 1162,
	"./bnb-pairs/ADA-BNB.svg": 1163,
	"./bnb-pairs/ALICE-BNB.svg": 1164,
	"./bnb-pairs/ALPA-BNB.svg": 1165,
	"./bnb-pairs/ALPACA-BNB.png": 1166,
	"./bnb-pairs/ALPHA-BNB.svg": 1167,
	"./bnb-pairs/APYS-BNB.svg": 1168,
	"./bnb-pairs/ARPA-BNB.svg": 1169,
	"./bnb-pairs/ASR-BNB.svg": 1170,
	"./bnb-pairs/ATA-BNB.svg": 1171,
	"./bnb-pairs/ATM-BNB.svg": 1172,
	"./bnb-pairs/ATOM-BNB.svg": 1173,
	"./bnb-pairs/AUTO-BNB.png": 1174,
	"./bnb-pairs/AVAX-BNB.svg": 1175,
	"./bnb-pairs/BAKE-BNB.png": 1176,
	"./bnb-pairs/BALBT-BNB.svg": 1177,
	"./bnb-pairs/BAND-BNB.svg": 1178,
	"./bnb-pairs/BAT-BNB.svg": 1179,
	"./bnb-pairs/BCH-BNB.svg": 1180,
	"./bnb-pairs/BDO-BNB.svg": 1181,
	"./bnb-pairs/BEL-BNB.svg": 1182,
	"./bnb-pairs/BELT-BNB-BELT.png": 1183,
	"./bnb-pairs/BELT-BNB.svg": 1184,
	"./bnb-pairs/BFI-BNB.svg": 1185,
	"./bnb-pairs/BHC-BNB.png": 1186,
	"./bnb-pairs/BIFI-BNB.png": 1187,
	"./bnb-pairs/BIFI-BNB.svg": 1188,
	"./bnb-pairs/BITI-BNB.png": 1189,
	"./bnb-pairs/BLIQ-BNB.png": 1190,
	"./bnb-pairs/BLK-BNB.svg": 1191,
	"./bnb-pairs/BLZ-BNB.svg": 1192,
	"./bnb-pairs/BMXX-BNB.svg": 1193,
	"./bnb-pairs/BONDLY-BNB.svg": 1194,
	"./bnb-pairs/BOPEN-BNB.svg": 1195,
	"./bnb-pairs/BOR-BNB.svg": 1196,
	"./bnb-pairs/BRY-BNB.svg": 1197,
	"./bnb-pairs/BSCX-BNB.svg": 1198,
	"./bnb-pairs/BTC-BNB.png": 1199,
	"./bnb-pairs/BTCB-BNB.svg": 1200,
	"./bnb-pairs/BTCST-BNB.svg": 1201,
	"./bnb-pairs/BTT-BNB.svg": 1202,
	"./bnb-pairs/BUNNY-BNB.svg": 1203,
	"./bnb-pairs/BUSD-BNB.png": 1204,
	"./bnb-pairs/BUSD-BNB.svg": 1205,
	"./bnb-pairs/BUX-BNB.svg": 1206,
	"./bnb-pairs/BXBTC-BNB.svg": 1207,
	"./bnb-pairs/CAKE-BNB.svg": 1208,
	"./bnb-pairs/CELR-BNB.svg": 1209,
	"./bnb-pairs/CGG-BNB.svg": 1210,
	"./bnb-pairs/COM-BNB.png": 1211,
	"./bnb-pairs/COMP-BNB.svg": 1212,
	"./bnb-pairs/COS-BNB.svg": 1213,
	"./bnb-pairs/COTI-BNB.svg": 1214,
	"./bnb-pairs/CRED-BNB.png": 1215,
	"./bnb-pairs/CTK-BNB.svg": 1216,
	"./bnb-pairs/CYC-BNB.svg": 1217,
	"./bnb-pairs/DAI-BNB.svg": 1218,
	"./bnb-pairs/DEGO-BNB.svg": 1219,
	"./bnb-pairs/DFT-BNB.svg": 1220,
	"./bnb-pairs/DITTO-BNB.svg": 1221,
	"./bnb-pairs/DODO-BNB.svg": 1222,
	"./bnb-pairs/DOGE-BNB-PCS.svg": 1223,
	"./bnb-pairs/DOGE-BNB.svg": 1224,
	"./bnb-pairs/DOT-BNB.svg": 1225,
	"./bnb-pairs/DRUGS-BNB.png": 1226,
	"./bnb-pairs/DUSK-BNB.svg": 1227,
	"./bnb-pairs/EASY-BNB.svg": 1228,
	"./bnb-pairs/EGLD-BNB.svg": 1229,
	"./bnb-pairs/EOS-BNB.svg": 1230,
	"./bnb-pairs/EPS-BNB.svg": 1231,
	"./bnb-pairs/ETC-BNB.svg": 1232,
	"./bnb-pairs/ETH-BNB.svg": 1233,
	"./bnb-pairs/EZ-BNB.svg": 1234,
	"./bnb-pairs/FIL-BNB.svg": 1235,
	"./bnb-pairs/FINE-BNB.svg": 1236,
	"./bnb-pairs/FRONT-BNB.svg": 1237,
	"./bnb-pairs/FTM-BNB.svg": 1238,
	"./bnb-pairs/FTS-BNB.svg": 1239,
	"./bnb-pairs/FUEL-BNB.png": 1240,
	"./bnb-pairs/GOLD-BNB.png": 1241,
	"./bnb-pairs/GUM-BNB.svg": 1242,
	"./bnb-pairs/GUNS-BNB.png": 1243,
	"./bnb-pairs/HARD-BNB.svg": 1244,
	"./bnb-pairs/HELMET-BNB.svg": 1245,
	"./bnb-pairs/HGET-BNB.svg": 1246,
	"./bnb-pairs/HYFI-BNB.svg": 1247,
	"./bnb-pairs/HZN-BNB.svg": 1248,
	"./bnb-pairs/INJ-BNB.svg": 1249,
	"./bnb-pairs/IOTA-BNB.svg": 1250,
	"./bnb-pairs/ITAM-BNB.svg": 1251,
	"./bnb-pairs/JBTCB-BNB.svg": 1252,
	"./bnb-pairs/JDOT-BNB.svg": 1253,
	"./bnb-pairs/JGN-BNB.png": 1254,
	"./bnb-pairs/JGN-BNB.svg": 1255,
	"./bnb-pairs/JTWT-BNB.svg": 1256,
	"./bnb-pairs/JULD-BNB.svg": 1257,
	"./bnb-pairs/JUNI-BNB.svg": 1258,
	"./bnb-pairs/JUV-BNB.svg": 1259,
	"./bnb-pairs/JXVS-BNB.svg": 1260,
	"./bnb-pairs/KALM-BNB.svg": 1261,
	"./bnb-pairs/KEBAB-BNB.png": 1262,
	"./bnb-pairs/KEYFI-BNB.svg": 1263,
	"./bnb-pairs/KTN-BNB.svg": 1264,
	"./bnb-pairs/LIEN-BNB.svg": 1265,
	"./bnb-pairs/LINK-BNB.svg": 1266,
	"./bnb-pairs/LIT-BNB.svg": 1267,
	"./bnb-pairs/LMT-BNB.svg": 1268,
	"./bnb-pairs/LTC-BNB.svg": 1269,
	"./bnb-pairs/LTO-BNB.svg": 1270,
	"./bnb-pairs/MATIC-BNB.svg": 1271,
	"./bnb-pairs/MBOX-BNB.svg": 1272,
	"./bnb-pairs/MDX-BNB.png": 1273,
	"./bnb-pairs/NAR-BNB.png": 1274,
	"./bnb-pairs/NAUT-BNB.svg": 1275,
	"./bnb-pairs/NEAR-BNB.svg": 1276,
	"./bnb-pairs/NRV-BNB.svg": 1277,
	"./bnb-pairs/ODDZ-BNB.svg": 1278,
	"./bnb-pairs/OG-BNB.svg": 1279,
	"./bnb-pairs/ONT-BNB.svg": 1280,
	"./bnb-pairs/PBTC-BNB.svg": 1281,
	"./bnb-pairs/PERL-BNB.svg": 1282,
	"./bnb-pairs/POPEN-BNB.svg": 1283,
	"./bnb-pairs/PSG-BNB.svg": 1284,
	"./bnb-pairs/REEF-BNB.svg": 1285,
	"./bnb-pairs/SFP-BNB.svg": 1286,
	"./bnb-pairs/SHIB-BNB.svg": 1287,
	"./bnb-pairs/SNX-BNB.svg": 1288,
	"./bnb-pairs/SOAK-BNB.svg": 1289,
	"./bnb-pairs/SPG-BNB.svg": 1290,
	"./bnb-pairs/STEAM-BNB.svg": 1291,
	"./bnb-pairs/SUTER-BNB.svg": 1292,
	"./bnb-pairs/SWAMP-BNB.svg": 1293,
	"./bnb-pairs/SWGB-BNB.svg": 1294,
	"./bnb-pairs/SWINGBY-BNB.svg": 1295,
	"./bnb-pairs/SWIRL-BNB.png": 1296,
	"./bnb-pairs/SWTH-BNB.svg": 1297,
	"./bnb-pairs/SXP-BNB.svg": 1298,
	"./bnb-pairs/TDOGE-BNB.svg": 1299,
	"./bnb-pairs/TEN-BNB.svg": 1300,
	"./bnb-pairs/THUGS-BNB.png": 1301,
	"./bnb-pairs/TKO-BNB.svg": 1302,
	"./bnb-pairs/TLM-BNB.svg": 1303,
	"./bnb-pairs/TRADE-BNB.svg": 1304,
	"./bnb-pairs/TRX-BNB.svg": 1305,
	"./bnb-pairs/TWT-BNB.svg": 1306,
	"./bnb-pairs/TYPH-BNB.png": 1307,
	"./bnb-pairs/UNFI-BNB.svg": 1308,
	"./bnb-pairs/UNI-BNB.svg": 1309,
	"./bnb-pairs/USDC-BNB.svg": 1310,
	"./bnb-pairs/USDT-BNB.svg": 1311,
	"./bnb-pairs/VAPOR-BNB.png": 1312,
	"./bnb-pairs/VIDT-BNB.svg": 1313,
	"./bnb-pairs/VRT-BNB.svg": 1314,
	"./bnb-pairs/WATCH-BNB-APE.svg": 1315,
	"./bnb-pairs/WATCH-BNB.svg": 1316,
	"./bnb-pairs/WEX-BNB.png": 1317,
	"./bnb-pairs/WIN-BNB.svg": 1318,
	"./bnb-pairs/WSOTE-BNB.svg": 1319,
	"./bnb-pairs/XED-BNB.svg": 1320,
	"./bnb-pairs/XEND-BNB.svg": 1321,
	"./bnb-pairs/XRP-BNB.svg": 1322,
	"./bnb-pairs/XTZ-BNB.svg": 1323,
	"./bnb-pairs/XVS-BNB.svg": 1324,
	"./bnb-pairs/YFI-BNB.svg": 1325,
	"./bnb-pairs/YFII-BNB.svg": 1326,
	"./bnb-pairs/ZEC-BNB.svg": 1327,
	"./bnb-pairs/ZEE-BNB.svg": 1328,
	"./bnb-pairs/ZIL-BNB.svg": 1329,
	"./bnb-pairs/bROOBEE-BNB.svg": 1330,
	"./bnb-pairs/bTRI-BNB.png": 1331,
	"./bnb-pairs/pCWS-BNB.svg": 1332,
	"./bnb-pairs/typh-bnb.svg": 1333,
	"./busd-pairs/ADA-BUSD.png": 1334,
	"./busd-pairs/ALPACA-BUSD.svg": 1335,
	"./busd-pairs/BAKE-BUSD.png": 1336,
	"./busd-pairs/BCFX-BUSD.svg": 1337,
	"./busd-pairs/BIFI-BUSD.png": 1338,
	"./busd-pairs/BTCB-BUSD.svg": 1339,
	"./busd-pairs/BTR-BUSD.svg": 1340,
	"./busd-pairs/BUSD-USDC.svg": 1341,
	"./busd-pairs/DAI-BUSD.png": 1342,
	"./busd-pairs/DAI-BUSD.svg": 1343,
	"./busd-pairs/DEXE-BUSD.svg": 1344,
	"./busd-pairs/DFD-BUSD.svg": 1345,
	"./busd-pairs/FOR-BUSD.svg": 1346,
	"./busd-pairs/HAKKA-BUSD.svg": 1347,
	"./busd-pairs/HOO-BUSD.svg": 1348,
	"./busd-pairs/IOTX-BUSD.svg": 1349,
	"./busd-pairs/KEBAB-BUSD.png": 1350,
	"./busd-pairs/KUN-BUSD.svg": 1351,
	"./busd-pairs/LINA-BUSD.svg": 1352,
	"./busd-pairs/LTC-BUSD.png": 1353,
	"./busd-pairs/MATH-BUSD.svg": 1354,
	"./busd-pairs/MDX-BUSD.png": 1355,
	"./busd-pairs/MTRG-BUSD.svg": 1356,
	"./busd-pairs/MX-BUSD.svg": 1357,
	"./busd-pairs/NULS-BUSD.svg": 1358,
	"./busd-pairs/OIN-BUSD.svg": 1359,
	"./busd-pairs/ONE-BUSD.svg": 1360,
	"./busd-pairs/PMON-BUSD.svg": 1361,
	"./busd-pairs/QKC-BUSD.svg": 1362,
	"./busd-pairs/RAMP-BUSD.svg": 1363,
	"./busd-pairs/SWAMP-BUSD.svg": 1364,
	"./busd-pairs/TPT-BUSD.svg": 1365,
	"./busd-pairs/TUSD-BUSD.svg": 1366,
	"./busd-pairs/TXL-BUSD.svg": 1367,
	"./busd-pairs/UBXT-BUSD.svg": 1368,
	"./busd-pairs/USDC-BUSD.svg": 1369,
	"./busd-pairs/USDT-BUSD.png": 1370,
	"./busd-pairs/USDT-BUSD.svg": 1371,
	"./busd-pairs/UST-BUSD.svg": 1372,
	"./busd-pairs/VAI-BUSD.svg": 1373,
	"./busd-pairs/WELL-BUSD.svg": 1374,
	"./busd-pairs/WMASS-BUSD.svg": 1375,
	"./busd-pairs/XMARK-BUSD.svg": 1376,
	"./busd-pairs/XRP-BUSD.png": 1377,
	"./cake-pairs/BROOBEE-CAKE.svg": 1378,
	"./cake-pairs/CAKE-BUSD.svg": 1379,
	"./cake-pairs/NAR-CAKE.svg": 1380,
	"./cake-pairs/NYA-CAKE.svg": 1381,
	"./cake-pairs/STAX-CAKE.svg": 1382,
	"./cake-pairs/ampl-bsc-mp-busd.svg": 1383,
	"./cake-pairs/btcb-eth.svg": 1384,
	"./cake-pairs/chr-busd.svg": 1385,
	"./cake-pairs/deri-busd.svg": 1386,
	"./cake-pairs/eth-usdc.svg": 1387,
	"./cake-pairs/hotcross-bnb.svg": 1388,
	"./cake-pairs/rfox-bnb.svg": 1389,
	"./crow/crow.png": 1390,
	"./degens/ADA-BNB.svg": 1391,
	"./degens/BANANA-DOT-BNB.svg": 1392,
	"./degens/BANANA-EPS-BNB.svg": 1393,
	"./degens/BANANA-SFP-BNB.svg": 1394,
	"./degens/BANANA-SUSHI-BNB.svg": 1395,
	"./degens/BANANA-TWT-BNB.svg": 1396,
	"./degens/BANANA-XRP-BNB.svg": 1397,
	"./degens/BANANA-XVS-BNB.svg": 1398,
	"./degens/BANANA.svg": 1399,
	"./degens/BGO.png": 1400,
	"./degens/BIFI-BNB-banana.svg": 1401,
	"./degens/BIFI-BNB.svg": 1402,
	"./degens/BITI.png": 1403,
	"./degens/BLZD-BNB.png": 1404,
	"./degens/BLZD-BUSD.png": 1405,
	"./degens/BLZD.png": 1406,
	"./degens/DND.png": 1407,
	"./degens/FTS-BNB.svg": 1408,
	"./degens/FUEL-BNB.svg": 1409,
	"./degens/GOAL-BUSD.png": 1410,
	"./degens/IRON.png": 1411,
	"./degens/LINK-BNB.svg": 1412,
	"./degens/NAUT.png": 1413,
	"./degens/PALM.png": 1414,
	"./degens/SAT-BNB.png": 1415,
	"./degens/SAT-BUSD.png": 1416,
	"./degens/SBGO.png": 1417,
	"./degens/SOUP-BNB.svg": 1418,
	"./degens/SOUPS-BNB.svg": 1419,
	"./degens/SPACE-BNB.png": 1420,
	"./degens/SPACE-BUSD.png": 1421,
	"./degens/STEEL.png": 1422,
	"./degens/WINGS-BNB-BUSD.svg": 1423,
	"./degens/WINGS-BNB.svg": 1424,
	"./degens/WINGS-BUSD.svg": 1425,
	"./degens/WINGS-USDC-BUSD.svg": 1426,
	"./degens/WINGS.svg": 1427,
	"./degens/ZEFI-BNB.svg": 1428,
	"./degens/ZEFI-BUSD.svg": 1429,
	"./degens/ape-bnb.png": 1430,
	"./degens/banana-bnb.svg": 1431,
	"./degens/banana-busd.svg": 1432,
	"./degens/banana-ltc-bnb.svg": 1433,
	"./degens/brew-bnb.svg": 1434,
	"./degens/brew-busd.svg": 1435,
	"./degens/garuda-bnb.png": 1436,
	"./degens/garuda-usdc.png": 1437,
	"./degens/garuda-usdt.png": 1438,
	"./degens/grand-bnb.png": 1439,
	"./degens/grand.png": 1440,
	"./degens/mash-bnb.png": 1441,
	"./degens/mash-busd.png": 1442,
	"./degens/mash.png": 1443,
	"./degens/mfrm-bnb.png": 1444,
	"./degens/palm-bnb.png": 1445,
	"./degens/palm-busd.png": 1446,
	"./degens/panther-bnb.png": 1447,
	"./degens/panther-busd.png": 1448,
	"./degens/ramen-bnb.svg": 1449,
	"./degens/ramen-busd.svg": 1450,
	"./degens/salt-bnb.png": 1451,
	"./degens/salt-busd.png": 1452,
	"./degens/sdump-bnb.png": 1453,
	"./degens/sdump-busd.png": 1454,
	"./degens/slime-bnb.png": 1455,
	"./degens/slime-busd.png": 1456,
	"./degens/tndr-bnb.png": 1457,
	"./degens/tndr-busd.png": 1458,
	"./degens/tofy-bnb.png": 1459,
	"./degens/tofy-mash.png": 1460,
	"./degens/tofy.png": 1461,
	"./eth-pairs/ADA-ETH.svg": 1462,
	"./eth-pairs/BETH-ETH.svg": 1463,
	"./eth-pairs/BTCB-ETH.svg": 1464,
	"./eth-pairs/ETH-BNB.png": 1465,
	"./eth-pairs/ETH-BTC.png": 1466,
	"./fantom/AAVE-FTM.png": 1467,
	"./fantom/ANY-FTM.png": 1468,
	"./fantom/BADGER-FTM.png": 1469,
	"./fantom/BAND-FTM.png": 1470,
	"./fantom/BIFI-FTM.png": 1471,
	"./fantom/BNB-FTM.png": 1472,
	"./fantom/BOO-FTM.png": 1473,
	"./fantom/BOO.png": 1474,
	"./fantom/BTC-FTM.png": 1475,
	"./fantom/COVER-FTM.png": 1476,
	"./fantom/CREAM-FTM.png": 1477,
	"./fantom/CRV-FTM.png": 1478,
	"./fantom/DAI-FTM.png": 1479,
	"./fantom/EST-FTM.png": 1480,
	"./fantom/EST.png": 1481,
	"./fantom/ETH-FTM.png": 1482,
	"./fantom/FROYO-3Pool.png": 1483,
	"./fantom/FROYO.png": 1484,
	"./fantom/ICE-FTM.png": 1485,
	"./fantom/LINK-FTM.png": 1486,
	"./fantom/SNX-FTM.png": 1487,
	"./fantom/SUSHI-FTM.png": 1488,
	"./fantom/TOMB-FTM.png": 1489,
	"./fantom/TSHARE-FTM.png": 1490,
	"./fantom/USDC-FTM.png": 1491,
	"./fantom/USDT-FTM.png": 1492,
	"./fantom/WOOFY-FTM.png": 1493,
	"./fantom/YFI-FTM.png": 1494,
	"./heco/AAVE-USDT.svg": 1495,
	"./heco/BAL-USDT.svg": 1496,
	"./heco/ETH-USDT.png": 1497,
	"./heco/ETH-WHT.svg": 1498,
	"./heco/HBCH-USDT.svg": 1499,
	"./heco/HBTC-USDT.png": 1500,
	"./heco/HBTC-WHT.svg": 1501,
	"./heco/HDOT-USDT.svg": 1502,
	"./heco/HFI-HT.png": 1503,
	"./heco/HFI-HUSD.png": 1504,
	"./heco/HFIL-USDT.svg": 1505,
	"./heco/HLTC-USDT.svg": 1506,
	"./heco/HPT-USDT.svg": 1507,
	"./heco/HUSD-USDT.svg": 1508,
	"./heco/HUSD.png": 1509,
	"./heco/LAVA-HT.svg": 1510,
	"./heco/LAVA-USDT.svg": 1511,
	"./heco/LAVA.png": 1512,
	"./heco/LHB-USDT.svg": 1513,
	"./heco/LHB-WHT.png": 1514,
	"./heco/LINK-USDT.svg": 1515,
	"./heco/MDX-USDT.png": 1516,
	"./heco/MDX-WHT.png": 1517,
	"./heco/SNX-USDT.svg": 1518,
	"./heco/UNI-USDT.svg": 1519,
	"./heco/WHT-HUSD.png": 1520,
	"./heco/WHT-USDT.png": 1521,
	"./heco/YFI-USDT.svg": 1522,
	"./heco/fHT.png": 1523,
	"./heco/fUNI.png": 1524,
	"./kebab/ETH-BTCB.png": 1525,
	"./kebab/KEBAB-BTCB.png": 1526,
	"./kebab/USDT-BUSD.png": 1527,
	"./polygon/AAVE-ETH.png": 1528,
	"./polygon/ADDY.png": 1529,
	"./polygon/ANY-QUICK.png": 1530,
	"./polygon/AZUKI-ETH.png": 1531,
	"./polygon/BIFI-ETH.png": 1532,
	"./polygon/BIFI-MATIC.png": 1533,
	"./polygon/BIFI-MUST.png": 1534,
	"./polygon/BIFI-QUICK.png": 1535,
	"./polygon/BTC-USDC.png": 1536,
	"./polygon/CC10-ETH.png": 1537,
	"./polygon/CC10-QUICK.png": 1538,
	"./polygon/CEL-ETH.png": 1539,
	"./polygon/CRV-ETH.png": 1540,
	"./polygon/CURVE-3Pool.png": 1541,
	"./polygon/DEFI5-ETH.png": 1542,
	"./polygon/DEFI5-QUICK.png": 1543,
	"./polygon/DEGEN-ETH.png": 1544,
	"./polygon/DEGEN-QUICK.png": 1545,
	"./polygon/DOKI-ETH.png": 1546,
	"./polygon/ETH-BTC.png": 1547,
	"./polygon/ETH-DAI.png": 1548,
	"./polygon/ETH-FIL.png": 1549,
	"./polygon/ETH-MATIC.png": 1550,
	"./polygon/ETH-USDT.png": 1551,
	"./polygon/FFF-QUICK.png": 1552,
	"./polygon/FISH-MATIC.svg": 1553,
	"./polygon/FRAX-FXS.png": 1554,
	"./polygon/FRAX-QUICK.png": 1555,
	"./polygon/FRAX-USDC.png": 1556,
	"./polygon/GRT-ETH.png": 1557,
	"./polygon/IRON-ETH.png": 1558,
	"./polygon/IRON-USDC.png": 1559,
	"./polygon/IRON.png": 1560,
	"./polygon/KRILL-USDC.png": 1561,
	"./polygon/LINK-ETH.png": 1562,
	"./polygon/LINK-QUICK.png": 1563,
	"./polygon/MATIC-USDC.png": 1564,
	"./polygon/MATIC-WOOFY.png": 1565,
	"./polygon/MIMATIC-USDC.png": 1566,
	"./polygon/MUST-ETH.png": 1567,
	"./polygon/MUST-MATIC.png": 1568,
	"./polygon/PZAP-MATIC.png": 1569,
	"./polygon/PZAP-USDC.png": 1570,
	"./polygon/QUICK-ETH.png": 1571,
	"./polygon/QUICK-MATIC.png": 1572,
	"./polygon/QUICK-UNI.png": 1573,
	"./polygon/SNX-ETH.png": 1574,
	"./polygon/TITAN-ETH.png": 1575,
	"./polygon/TITAN-IRON.png": 1576,
	"./polygon/TITAN-MATIC.png": 1577,
	"./polygon/TITAN.png": 1578,
	"./polygon/UBT-ETH.png": 1579,
	"./polygon/USDC-DAI.png": 1580,
	"./polygon/USDC-ETH.png": 1581,
	"./polygon/USDC-MUST.png": 1582,
	"./polygon/USDC-USDT.png": 1583,
	"./polygon/VISION-ETH.png": 1584,
	"./polygon/VISION-QUICK.png": 1585,
	"./polygon/WEX-MATIC.png": 1586,
	"./polygon/WEX-USDC.png": 1587,
	"./polygon/WEX.png": 1588,
	"./polygon/WEXPOLY-BTC.png": 1589,
	"./polygon/WISE-ETH.png": 1590,
	"./polygon/mOCEAN-MATIC.png": 1591,
	"./polygon/maUSDC-USDC.png": 1592,
	"./polygon/renDOGE-ETH.png": 1593,
	"./single-assets/AAVE.svg": 460,
	"./single-assets/ADA.svg": 461,
	"./single-assets/ADX.svg": 462,
	"./single-assets/ANY.png": 463,
	"./single-assets/ATOM.png": 464,
	"./single-assets/AVAX.png": 465,
	"./single-assets/BAKE.png": 466,
	"./single-assets/BANANA.svg": 467,
	"./single-assets/BCH.svg": 468,
	"./single-assets/BDO.png": 469,
	"./single-assets/BETH.png": 470,
	"./single-assets/BHC.png": 471,
	"./single-assets/BIFI.png": 472,
	"./single-assets/BNB.png": 473,
	"./single-assets/BONE.png": 474,
	"./single-assets/BONEswap.png": 475,
	"./single-assets/BOO.png": 476,
	"./single-assets/BORING.png": 477,
	"./single-assets/BSCPAD.png": 478,
	"./single-assets/BTCB.svg": 479,
	"./single-assets/BTD.png": 480,
	"./single-assets/BTS.png": 481,
	"./single-assets/BUNNY.png": 482,
	"./single-assets/BURGER.png": 483,
	"./single-assets/BUSD.svg": 484,
	"./single-assets/CAKE.svg": 485,
	"./single-assets/CARROT.png": 486,
	"./single-assets/CHESS.svg": 487,
	"./single-assets/CTK.png": 488,
	"./single-assets/DAI.png": 489,
	"./single-assets/DAI.svg": 490,
	"./single-assets/DFYN.png": 491,
	"./single-assets/DG.png": 492,
	"./single-assets/DOT.png": 493,
	"./single-assets/DRUGS.png": 494,
	"./single-assets/DVI.svg": 495,
	"./single-assets/ETH.svg": 496,
	"./single-assets/EZ.png": 497,
	"./single-assets/FANTOM.png": 498,
	"./single-assets/FFF.png": 499,
	"./single-assets/FIL.svg": 500,
	"./single-assets/FISH.svg": 501,
	"./single-assets/FORM.svg": 502,
	"./single-assets/FTM.png": 503,
	"./single-assets/HAI.png": 504,
	"./single-assets/HARD.png": 505,
	"./single-assets/HBTC.png": 506,
	"./single-assets/HECO.png": 507,
	"./single-assets/HPS.png": 508,
	"./single-assets/HT.png": 509,
	"./single-assets/HTB.svg": 510,
	"./single-assets/HUSD.png": 511,
	"./single-assets/ICA.svg": 512,
	"./single-assets/ICE.png": 513,
	"./single-assets/INCH.png": 514,
	"./single-assets/INJ.png": 515,
	"./single-assets/JETS.png": 516,
	"./single-assets/JULD.png": 517,
	"./single-assets/KEBAB.png": 518,
	"./single-assets/KROWN.png": 519,
	"./single-assets/LINK.png": 520,
	"./single-assets/LTC.svg": 521,
	"./single-assets/MAI.png": 522,
	"./single-assets/MARSH.png": 523,
	"./single-assets/MASK.svg": 524,
	"./single-assets/MATIC.svg": 525,
	"./single-assets/MDX.png": 526,
	"./single-assets/MERL.svg": 527,
	"./single-assets/MIM.png": 528,
	"./single-assets/MSC.png": 529,
	"./single-assets/MSS.png": 530,
	"./single-assets/NEXO.png": 531,
	"./single-assets/NUTS.png": 532,
	"./single-assets/NYA.png": 533,
	"./single-assets/NYAC.png": 534,
	"./single-assets/NYAS.png": 535,
	"./single-assets/O3.png": 536,
	"./single-assets/ONE.svg": 537,
	"./single-assets/OOE.svg": 538,
	"./single-assets/ORBS.svg": 539,
	"./single-assets/PBNB.png": 540,
	"./single-assets/PMP.svg": 541,
	"./single-assets/PNG.svg": 542,
	"./single-assets/POLYGON.png": 543,
	"./single-assets/PUP.png": 544,
	"./single-assets/PolyDoge.png": 545,
	"./single-assets/QI.png": 546,
	"./single-assets/QUICK.png": 547,
	"./single-assets/RABBIT.svg": 548,
	"./single-assets/RAMP.png": 549,
	"./single-assets/ROUTE.png": 550,
	"./single-assets/SBDO.png": 551,
	"./single-assets/SFP.png": 552,
	"./single-assets/SMART.png": 553,
	"./single-assets/SNX.png": 554,
	"./single-assets/SOAK.png": 555,
	"./single-assets/SPIRIT.png": 556,
	"./single-assets/STEEL.png": 557,
	"./single-assets/SUSHI.png": 558,
	"./single-assets/SWAMP.svg": 559,
	"./single-assets/SX.png": 560,
	"./single-assets/SXP.svg": 561,
	"./single-assets/TEL.png": 562,
	"./single-assets/TENFI.png": 563,
	"./single-assets/TITAN.svg": 564,
	"./single-assets/TYPH.png": 565,
	"./single-assets/UFT.png": 566,
	"./single-assets/UNI.png": 567,
	"./single-assets/USDC.svg": 568,
	"./single-assets/USDT.svg": 569,
	"./single-assets/WATCH.png": 570,
	"./single-assets/WAULTx.svg": 571,
	"./single-assets/WBNB.svg": 572,
	"./single-assets/WBTC.svg": 573,
	"./single-assets/WEX.svg": 574,
	"./single-assets/WOO.svg": 575,
	"./single-assets/WOOFY.png": 576,
	"./single-assets/XRP.svg": 577,
	"./single-assets/XTZ.png": 578,
	"./single-assets/XVS.png": 579,
	"./single-assets/YELD.png": 580,
	"./single-assets/YFI.png": 581,
	"./single-assets/ZBTC.svg": 582,
	"./single-assets/ZETH.svg": 583,
	"./single-assets/cakeHARD.png": 584,
	"./single-assets/cakeROOBEE.png": 585,
	"./single-assets/cakeSTAX.png": 586,
	"./single-assets/cakeTWT.png": 587,
	"./single-assets/cakebROOBEE.png": 588,
	"./single-assets/fUSDT.png": 589,
	"./single-assets/ibBTC.svg": 590,
	"./single-assets/pWINGS.png": 591,
	"./single-assets/polyBUNNY.png": 592,
	"./single-assets/rUSD.svg": 593,
	"./single-assets/renBTC.png": 594,
	"./single-assets/sALPACA.svg": 595,
	"./stake/apeswap/background.png": 1594,
	"./stake/apeswap/logo.png": 1595,
	"./stake/apyswap/background.png": 1596,
	"./stake/apyswap/logo.png": 1597,
	"./stake/astronaut/background.png": 1598,
	"./stake/astronaut/logo.png": 1599,
	"./stake/beefy/background.png": 1600,
	"./stake/beefy/beefyfinance.png": 1601,
	"./stake/beefy/beefyfinance_night.png": 1602,
	"./stake/billionhappiness/background.png": 1603,
	"./stake/billionhappiness/logo.png": 1604,
	"./stake/bingo/background.png": 1605,
	"./stake/bingo/logo.png": 1606,
	"./stake/biticity/background.png": 1607,
	"./stake/biticity/logo.png": 1608,
	"./stake/boneswap/background.png": 1609,
	"./stake/boneswap/logo.png": 1610,
	"./stake/boost.svg": 182,
	"./stake/cafeswap/background.png": 1611,
	"./stake/cafeswap/brew.png": 1612,
	"./stake/cafeswap/cafeswap.png": 1613,
	"./stake/crowfinance/background.png": 1614,
	"./stake/crowfinance/crow.png": 1615,
	"./stake/crowfinance/crowfinance.png": 1616,
	"./stake/dopple/background.png": 1617,
	"./stake/dopple/logo.png": 1618,
	"./stake/dumpling/background.png": 1619,
	"./stake/dumpling/logo.png": 1620,
	"./stake/esterfinance/background.png": 1621,
	"./stake/esterfinance/logo.png": 1622,
	"./stake/f1.png": 597,
	"./stake/fanatics/logo.png": 1623,
	"./stake/fire.png": 301,
	"./stake/garuda/logo.png": 1624,
	"./stake/grandbanks/background.png": 1625,
	"./stake/grandbanks/logo.png": 1626,
	"./stake/icarus/background.png": 1627,
	"./stake/icarus/logo.png": 1628,
	"./stake/ironfinance/background.png": 1629,
	"./stake/ironfinance/logo.png": 1630,
	"./stake/jetswap/background.png": 1631,
	"./stake/jetswap/logo.png": 1632,
	"./stake/krown/background.png": 1633,
	"./stake/krown/logo.png": 1634,
	"./stake/launchpool.png": 598,
	"./stake/mash/background.png": 1635,
	"./stake/mash/logo.png": 1636,
	"./stake/memefarm/ape.png": 1637,
	"./stake/memefarm/background.png": 1638,
	"./stake/memefarm/logo.png": 1639,
	"./stake/merlin/background.png": 1640,
	"./stake/merlin/logo.png": 1641,
	"./stake/panther/background.png": 1642,
	"./stake/panther/logo.png": 1643,
	"./stake/polygon/background.png": 1644,
	"./stake/polygon/logo.png": 1645,
	"./stake/polypup/background.png": 1646,
	"./stake/polypup/logo.png": 1647,
	"./stake/polyyeld/background.png": 1648,
	"./stake/polyyeld/logo.png": 1649,
	"./stake/qidao/background.png": 1650,
	"./stake/qidao/logo.png": 1651,
	"./stake/ramenswap/background.png": 1652,
	"./stake/ramenswap/ramen.png": 1653,
	"./stake/ramenswap/ramenswap.png": 1654,
	"./stake/safefarm/background.png": 1655,
	"./stake/safefarm/logo.png": 1656,
	"./stake/saltswap/background.png": 1657,
	"./stake/saltswap/salt.png": 1658,
	"./stake/saltswap/saltswap.png": 1659,
	"./stake/satis/background.png": 1660,
	"./stake/satis/logo.png": 1661,
	"./stake/slimefinance/background.png": 1662,
	"./stake/slimefinance/logo.png": 1663,
	"./stake/slimefinance/slime.png": 1664,
	"./stake/soup/background.png": 1665,
	"./stake/soup/logo.png": 1666,
	"./stake/space/background.png": 1667,
	"./stake/space/logo.png": 1668,
	"./stake/squirrel/background.png": 1669,
	"./stake/squirrel/logo.png": 1670,
	"./stake/squirrel/nuts.png": 1671,
	"./stake/swirl/background.png": 1672,
	"./stake/swirl/logo.png": 1673,
	"./stake/tenfi/background.png": 1674,
	"./stake/tenfi/logo.png": 1675,
	"./stake/thunder/background.png": 1676,
	"./stake/thunder/logo.png": 1677,
	"./stake/thypoon/background.png": 1678,
	"./stake/thypoon/logo.png": 1679,
	"./stake/tombfinance/background.png": 1680,
	"./stake/tombfinance/logo.png": 1681,
	"./stake/xbtc/background.png": 1682,
	"./stake/xbtc/logo.png": 1683,
	"./stake/yieldbay/background.png": 1684,
	"./stake/yieldbay/logo.png": 1685,
	"./stake/zcore/background.png": 1686,
	"./stake/zcore/logo.png": 1687,
	"./uncategorized/ATRICRYPTO.png": 1688,
	"./uncategorized/BADGER-BTCB.svg": 1689,
	"./uncategorized/BAT-BAKE.svg": 1690,
	"./uncategorized/BDIGG-BTCB.svg": 1691,
	"./uncategorized/BELT-VENUSBLP.png": 1692,
	"./uncategorized/BETH-ETH.svg": 1693,
	"./uncategorized/COMP-ETH.svg": 1694,
	"./uncategorized/DOPPLE-DOLLY-LP.svg": 1695,
	"./uncategorized/DOPPLE-DOP-LP.svg": 1696,
	"./uncategorized/DOPPLE-UST-LP.png": 1697,
	"./uncategorized/EPS-FUSDT.png": 1698,
	"./uncategorized/EPS.png": 1699,
	"./uncategorized/EPS3.png": 1700,
	"./uncategorized/ETH-USDT.png": 1701,
	"./uncategorized/IRON-3USD.png": 1702,
	"./uncategorized/PNT-PBTC.svg": 1703,
	"./uncategorized/SUSHI-ETH.svg": 1704,
	"./uncategorized/TBTC-BTCB.svg": 1705,
	"./uncategorized/THUGS-NAR.png": 1706,
	"./uncategorized/bTRI-CRED.png": 1707,
	"./uncategorized/pbtcEPS.png": 1708,
	"./uncategorized/renBTC-BTC.png": 1709,
	"./usdt-pairs/ALPACA-USDT.png": 1710,
	"./usdt-pairs/BIFI-USDT.png": 1711,
	"./usdt-pairs/BNB-USDT.png": 1712,
	"./usdt-pairs/BTCB-USDT.svg": 1713,
	"./usdt-pairs/ETH-USDT.svg": 1714,
	"./usdt-pairs/FIL-USDT.png": 1715,
	"./usdt-pairs/LHB-USDT.png": 1716,
	"./usdt-pairs/LYD-USDT.png": 1717,
	"./usdt-pairs/MATIC-USDT.png": 1718,
	"./usdt-pairs/SHIB-USDT.png": 1719,
	"./usdt-pairs/WEX-USDT.png": 1720,
	"./ust-pairs/MAMZN-UST.svg": 1721,
	"./ust-pairs/MCOIN-UST.svg": 1722,
	"./ust-pairs/MGOOGL-UST.svg": 1723,
	"./ust-pairs/MIR-UST.svg": 1724,
	"./ust-pairs/MNFLX-UST.svg": 1725,
	"./ust-pairs/MTSLA-UST.svg": 1726,
	"./wallets/binance-wallet.png": 442,
	"./wallets/math-wallet.svg": 296,
	"./wallets/metamask.png": 1727,
	"./wallets/metamask.svg": 1728,
	"./wallets/safepal-wallet.svg": 444,
	"./wallets/trust-wallet.svg": 443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;